const LABELS = {
    performanceCurves: "Performance curves",
    importFromExcel: "Import from excel",
    exportToExcel: "Export to excel",
    clearData: "Clear data",
    btnImport: "Import",
    typePrimary: "primary",
    excelInputs: "Excel inputs",
    md: "MD",
    inc: "INC",
    dls: "DLS",
    azi: "AZI",
    startCellLocation: "Start cell location",
    endCellLocation: "End cell location",
    sheetName: "Sheet name",
    includeInMainReport: "Include in main report",
    kop: "KOP (ft)",
    topESPPump: "Top of ESP pump (ft)",
    bottomESPSensor: "Bottom of ESP sensor (ft)",
    maxDLSaboveKop: "Max DLS above KOP",
    depthOfMaxDLS: "Depth of max DLS (ft)",
    casingSize: "Casing size",
    transitionZone: "Transition zone (TZ)",
    espLength: "ESP length (ft)",
    tailPipeDesander: "Tail Pipe + Desander (ft)",
    tailPipeBottom: "Tail pipe bottom (ft)",
    tailPipeInsideTZ: "% Tail pipe inside TZ",
    tubingSize: "Tubing size",
    espSettingDepthSUrvey: "ESP setting depth survey",
    notes: "Notes",
    exportWellSurveyPlot1: "Export well survey plot 1",
    exportWellSurveyPlot2: "Export well survey plot 2",
    headCurves: "Head curves",
    wellsurveyplot1: "Well survey plot 1",
    wellsurveyplot2: "Well survey plot 2",
};

export default LABELS;